import { Component, OnInit } from '@angular/core';
import { ThemeCustomizerService } from '../../common/theme-customizer/theme-customizer.service';

interface HeroStat {
  label: string;
  value: string;
}

interface EdcMember {
  sno: number;
  name: string;
  position: string;
  category: string;
  occupation: string;
}

@Component({
  selector: 'app-courses-grid-style-three-columns-two-page',
  templateUrl: './courses-grid-style-three-columns-two-page.component.html',
  styleUrls: ['./courses-grid-style-three-columns-two-page.component.scss']
})
export class CoursesGridStyleThreeColumnsTwoPageComponent implements OnInit {
  isToggled = false;

  pageTitle = 'Entrepreneurship Development Cell';
  pageSubtitle =
    'Encouraging leadership, innovation, industry exposure, and entrepreneurial thinking among students.';

  admissionNotice =
    'Admissions open for 2026 : B.E (CIVIL), B.E (CSE), B.E (CSE - AI & ML), B.E (CSE - CS), B.E (ECE), B.E (EEE), B.E (MECH), MBA, M.E (CSE), M.E (Embedded System Technologies), M.E (Thermal Engineering).';

  heroStats: HeroStat[] = [
    { label: 'Focus', value: 'Entrepreneurial Thinking' },
    { label: 'Growth', value: 'Leadership Development' },
    { label: 'Exposure', value: 'Industry Interaction' },
    { label: 'Outcome', value: 'Innovation & Skills' }
  ];

  edcIntro =
    'The Entrepreneurship Development Cell is reconstituted for the academic year 2025-2026. This committee will meet as and when required to look into the development of entrepreneurial skill among the students.';

  edcMembers: EdcMember[] = [
    {
      sno: 1,
      name: 'Dr. P. Nelson Raja',
      position: 'Chairman',
      category: 'Principal',
      occupation: 'Principal'
    },
    {
      sno: 2,
      name: 'Dr. G. Dhinesh',
      position: 'Co-Ordinator',
      category: 'Faculty Member',
      occupation: 'Professor'
    },
    {
      sno: 3,
      name: 'Mrs. P. Geetha',
      position: 'Co Co-ordinator',
      category: 'Faculty Member',
      occupation: 'Assistant Professor'
    },
    {
      sno: 4,
      name: 'Mr. B. M. Gnanasekaran',
      position: 'Member',
      category: 'Faculty Member',
      occupation: 'Assistant Professor'
    },
    {
      sno: 5,
      name: 'Mrs. A. Asiya Mariam',
      position: 'Member',
      category: 'Faculty Member',
      occupation: 'Assistant Professor'
    },
    {
      sno: 6,
      name: 'Mr. G. Alagumurugan',
      position: 'Member',
      category: 'Faculty Member',
      occupation: 'Assistant Professor'
    },
    {
      sno: 7,
      name: 'Mrs. M. Aishwarya',
      position: 'Member',
      category: 'Faculty Member',
      occupation: 'Assistant Professor'
    },
    {
      sno: 8,
      name: 'Mr. M. Selvakumar',
      position: 'Member',
      category: 'Faculty Member',
      occupation: 'Assistant Professor'
    },
    {
      sno: 9,
      name: 'Ms. M. Aishwarya',
      position: 'Member',
      category: 'Faculty Member',
      occupation: 'Assistant Professor'
    },
    {
      sno: 10,
      name: 'Mr. G. Balakrishnan',
      position: 'Member',
      category: 'Faculty Member',
      occupation: 'Assistant Professor'
    }
  ];

  edcParagraphs: string[] = [
    'FMCET has built an excellent track record of implementing high-impact entrepreneurship programs.',
    'To inculcate successful leadership traits among students, the Entrepreneurship Development Cell (EDC) conducts extensive programs and workshops.',
    'It works closely with several reputed industries and corporates. This relationship facilitates joint research, funded projects, and also provides opportunities to learn the latest technologies.'
  ];

  edcHighlights: string[] = [
    'High-impact entrepreneurship programmes for student development.',
    'Extensive workshops to build leadership and entrepreneurial traits.',
    'Strong collaboration with reputed industries and corporates.',
    'Support for joint research, funded projects, and technology learning.'
  ];

  constructor(public themeService: ThemeCustomizerService) {
    this.themeService.isToggled$.subscribe((isToggled) => {
      this.isToggled = isToggled;
    });
  }

  toggleTheme(): void {
    this.themeService.toggleTheme();
  }

  ngOnInit(): void {}
}